import React, { useState, useEffect } from 'react'
import {Form, Button, Dropdown} from "react-bootstrap";
import axios from 'axios';
import QrCodeScannerModal from "../components/modal/qrCodeScannerModal/qrCodeScannerModal";
import SettingsHeader from './console/SettingsHeader'
import ConsoleNavMenu from './console/ConsoleNavMenu';

function Settings(){
    const [errorInfo, setErrorInfo] = useState(<div></div>);
    const [isQrCodeScannerModalOpen, setQrCodeScannerModalOpen] = useState(false);
    const [codeValue, setCodeValue] = useState('');
    const [version, setVersion] = useState('Version');

    const onChangeCodeInput = (event) => {
        event.preventDefault();
        setCodeValue(event.target.value);
    };

    const onScanQrCodeClick = () => {
        setQrCodeScannerModalOpen(true);
    }

    const onDecode = (decodedText) => {
        setCodeValue(decodedText.match("IMEI:([0-9]*)")[1]);
        setQrCodeScannerModalOpen(false);
    }

    useEffect(() => {
        console.log("settings mount");
      }, []);

    useEffect(() => {
        return () => {
            console.log("settings unmount");
        };
    }, []);

    function submitFormCreateImeiModem(event){
        event.preventDefault()
        console.log(codeValue)
    
        axios.post('api/settings/insertModem', {imei: codeValue, version: Number(version)})
            .then(response => {console.log(response); setErrorInfo(<div style={{color: "red", paddingTop: "10px"}}>imei: {codeValue} добавлен</div>)})
            .catch((error) => {
                console.log(error.response);
                setErrorInfo(<div style={{color: "red", paddingTop: "10px"}}>Ошибка добавления</div>);
            });
    }

    return(
        <>
            <ConsoleNavMenu />
            <div className='blocks'>
                <div className='body-box'>
                    <h2>Create imei:</h2>
                    <Form onSubmit={submitFormCreateImeiModem} style={{width: "300px"}}>
                        <Form.Control type="text" 
                            placeholder="IMEI" 
                            value={codeValue}
                            onChange={onChangeCodeInput}
                        />
                        <br />
                        <Button variant="secondary" onClick={onScanQrCodeClick} style={{width: "300px"}}>
                            Scan QR-Code
                        </Button>
                        <br />
                        <br />
                        
                        <Dropdown>
                            <Dropdown.Toggle variant="success" id="dropdown-basic" style={{width: "300px"}}>
                                {version}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => setVersion('1004')}>Telemetry 1004</Dropdown.Item>
                                <Dropdown.Item onClick={() => setVersion('1005')}>Telem Rus 1005</Dropdown.Item>
                                <Dropdown.Item onClick={() => setVersion('2001')}>EYE (2001)</Dropdown.Item>
                                <Dropdown.Item onClick={() => setVersion('2002')}>EYE webRtc (2002)</Dropdown.Item>
                                <Dropdown.Item onClick={() => setVersion('2011')}>EYE2 (2011)</Dropdown.Item>
                                <Dropdown.Item onClick={() => setVersion('3001')}>Astra (3001)</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <br />
                        <Button variant="primary" type="submit" style={{width: "300px"}}>
                            Insert
                        </Button>
                    </Form>
                    {errorInfo}
                </div>
                <QrCodeScannerModal
                    show={isQrCodeScannerModalOpen}
                    onDecode={onDecode}
                    onClose={() => setQrCodeScannerModalOpen(false)}
                />
            </div>
        </>
        
    )
}

export default Settings;
